export enum OfmJobStatus {
  CRIADO = "CRIADO",
  AGENDADO = "AGENDADO",
  EXECUTANDO = "EXECUTANDO",
  CONCLUIDO = "CONCLUIDO",
  FALHA = "FALHA",
  CANCELADO = "CANCELADO",
}

export enum InvoiceType {
  ENTRY = "E",
  EXIT = "S",
}

export enum CodInvoiceModel {
  NFe = "55",
  NFCe = "65",
  Both = "Both",
}

export const InvoiceModelLabelPT: Record<string, string> = {
  "55": "55",
  "65": "65",
  "Both": "Ambos",
};

export const invoiceModelLabel = (v?: string) => (v && InvoiceModelLabelPT[v]) ?? v ?? "-";

export const OMF_TIME_ZONE = "America/Sao_Paulo";
export const OFM_LOCALE = "pt-BR";